import "core-js/modules/es.array.push.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1bb5278d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "left fontCoarse",
  style: {
    "height": "186px",
    "align-items": "center",
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "0球"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "1球"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "2球"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "3球"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "u-batNum"
};
const _hoisted_8 = {
  class: "u-img"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "content"
};
const _hoisted_11 = {
  class: "u-batNum"
};
const _hoisted_12 = {
  class: "u-img"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "content"
};
const _hoisted_15 = {
  class: "u-batNum"
};
const _hoisted_16 = {
  class: "u-img"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  class: "content"
};
const _hoisted_19 = {
  class: "u-batNum"
};
const _hoisted_20 = {
  class: "u-img"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "4球"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "5球"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "6球"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "7球"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
})], -1));
const _hoisted_26 = {
  class: "content"
};
const _hoisted_27 = {
  class: "u-batNum"
};
const _hoisted_28 = {
  class: "u-img"
};
const _hoisted_29 = ["src"];
const _hoisted_30 = {
  class: "content"
};
const _hoisted_31 = {
  class: "u-batNum"
};
const _hoisted_32 = {
  class: "u-img"
};
const _hoisted_33 = ["src"];
const _hoisted_34 = {
  class: "content"
};
const _hoisted_35 = {
  class: "u-batNum"
};
const _hoisted_36 = {
  class: "u-img"
};
const _hoisted_37 = ["src"];
const _hoisted_38 = {
  class: "content"
};
const _hoisted_39 = {
  class: "u-batNum"
};
const _hoisted_40 = {
  class: "u-img"
};
const _hoisted_41 = ["src"];
import { ref } from 'vue';
export default {
  __name: 'TtgView',
  setup(__props, {
    expose: __expose
  }) {
    const ttgList = ref([]);
    const changeList = ref([]);
    const pushTtgList = list => {
      ttgList.value = list;
      if (list.length > 0) {
        let up = "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_sjt.png";
        let down = "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_xjt.png";
        let initTtg = list[0];
        let lastTtg = list[list.length - 1];
        let change = [];
        let s0f = 0;
        let s1f = 0;
        let s2f = 0;
        let s3f = 0;
        let s4f = 0;
        let s5f = 0;
        let s6f = 0;
        let s7f = 0;
        change.push({
          name: "初始:" + initTtg.updateTime,
          s0: initTtg.s0,
          s1: initTtg.s1,
          s2: initTtg.s2,
          s3: initTtg.s3,
          s4: initTtg.s4,
          s5: initTtg.s5,
          s6: initTtg.s6,
          s7: initTtg.s7,
          s0f: s0f,
          s1f: s1f,
          s2f: s2f,
          s3f: s3f,
          s4f: s4f,
          s5f: s5f,
          s6f: s6f,
          s7f: s7f
        });
        s0f = parseFloat(initTtg.s0) > parseFloat(lastTtg.s0) ? down : parseFloat(initTtg.s0) < parseFloat(lastTtg.s0) ? up : '';
        s1f = parseFloat(initTtg.s1) > parseFloat(lastTtg.s1) ? down : parseFloat(initTtg.s1) < parseFloat(lastTtg.s1) ? up : '';
        s2f = parseFloat(initTtg.s2) > parseFloat(lastTtg.s2) ? down : parseFloat(initTtg.s2) < parseFloat(lastTtg.s2) ? up : '';
        s3f = parseFloat(initTtg.s3) > parseFloat(lastTtg.s3) ? down : parseFloat(initTtg.s3) < parseFloat(lastTtg.s3) ? up : '';
        s4f = parseFloat(initTtg.s4) > parseFloat(lastTtg.s4) ? down : parseFloat(initTtg.s4) < parseFloat(lastTtg.s4) ? up : '';
        s5f = parseFloat(initTtg.s5) > parseFloat(lastTtg.s5) ? down : parseFloat(initTtg.s5) < parseFloat(lastTtg.s5) ? up : '';
        s6f = parseFloat(initTtg.s6) > parseFloat(lastTtg.s6) ? down : parseFloat(initTtg.s6) < parseFloat(lastTtg.s6) ? up : '';
        s7f = parseFloat(initTtg.s7) > parseFloat(lastTtg.s7) ? down : parseFloat(initTtg.s7) < parseFloat(lastTtg.s7) ? up : '';
        change.push({
          name: "最新:" + lastTtg.updateTime,
          s0: lastTtg.s0,
          s1: lastTtg.s1,
          s2: lastTtg.s2,
          s3: lastTtg.s3,
          s4: lastTtg.s4,
          s5: lastTtg.s5,
          s6: lastTtg.s6,
          s7: lastTtg.s7,
          s0f: s0f,
          s1f: s1f,
          s2f: s2f,
          s3f: s3f,
          s4f: s4f,
          s5f: s5f,
          s6f: s6f,
          s7f: s7f
        });
        changeList.value = change;
      }
    };
    // 暴露给外部使用的函数
    __expose({
      pushTtgList
    });
    return (_ctx, _cache) => {
      const _component_nut_divider = _resolveComponent("nut-divider");
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_nut_divider, {
        "content-position": "left"
      }, {
        default: _withCtx(() => [_createTextVNode("总进球")]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changeList.value, (change, index) => {
        return _openBlock(), _createBlock(_component_nut_row, {
          key: index
        }, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(change.name), 1)]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_nut_row, null, {
              default: _withCtx(() => [_createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_2]),
                _: 1
              }), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_3]),
                _: 1
              }), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_4]),
                _: 1
              }), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_5]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_nut_row, null, {
              default: _withCtx(() => [_createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(change.s0), 1), _createElementVNode("span", _hoisted_8, [_createElementVNode("img", {
                  alt: "",
                  src: change.s0f
                }, null, 8, _hoisted_9)])])]),
                _: 2
              }, 1024), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(change.s1), 1), _createElementVNode("span", _hoisted_12, [_createElementVNode("img", {
                  alt: "",
                  src: change.s1f
                }, null, 8, _hoisted_13)])])]),
                _: 2
              }, 1024), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(change.s2), 1), _createElementVNode("span", _hoisted_16, [_createElementVNode("img", {
                  alt: "",
                  src: change.s2f
                }, null, 8, _hoisted_17)])])]),
                _: 2
              }, 1024), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString(change.s3), 1), _createElementVNode("span", _hoisted_20, [_createElementVNode("img", {
                  alt: "",
                  src: change.s3f
                }, null, 8, _hoisted_21)])])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024), _createVNode(_component_nut_row, null, {
              default: _withCtx(() => [_createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_22]),
                _: 1
              }), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_23]),
                _: 1
              }), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_24]),
                _: 1
              }), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_hoisted_25]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_nut_row, null, {
              default: _withCtx(() => [_createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(change.s4), 1), _createElementVNode("span", _hoisted_28, [_createElementVNode("img", {
                  alt: "",
                  src: change.s4f
                }, null, 8, _hoisted_29)])])]),
                _: 2
              }, 1024), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_createElementVNode("span", _hoisted_31, _toDisplayString(change.s5), 1), _createElementVNode("span", _hoisted_32, [_createElementVNode("img", {
                  alt: "",
                  src: change.s5f
                }, null, 8, _hoisted_33)])])]),
                _: 2
              }, 1024), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_34, [_createElementVNode("span", _hoisted_35, _toDisplayString(change.s6), 1), _createElementVNode("span", _hoisted_36, [_createElementVNode("img", {
                  alt: "",
                  src: change.s6f
                }, null, 8, _hoisted_37)])])]),
                _: 2
              }, 1024), _createVNode(_component_nut_col, {
                span: 6
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_createElementVNode("span", _hoisted_39, _toDisplayString(change.s7), 1), _createElementVNode("span", _hoisted_40, [_createElementVNode("img", {
                  alt: "",
                  src: change.s7f
                }, null, 8, _hoisted_41)])])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024);
      }), 128))], 64);
    };
  }
};